module.exports = __webpack_public_path__ + "img/tu3.49112867.png";